import { createAsyncThunk } from "@reduxjs/toolkit";
import apiConfig from "constants/apiConfig";
import { fetchRegions } from "services/api/master";
import { AuthState } from "slices/auth/reducer";
import { ERROR } from "types";
import { MasterSlice } from "types/master";
import { getErrorMessage, isFresh } from "utils/helpers";

export const fetchRegionsList = createAsyncThunk<string[], void, {rejectValue: string}> (
    'master/regions',
    async (_, {getState, rejectWithValue}) => {
        const state = getState() as {auth: AuthState, master: MasterSlice}
        const selectedAgencyId = state.auth.selectedAgencyId;
        if(!selectedAgencyId) throw new Error("No agency selected!")
        const STALE_TIME = apiConfig.FETCH_REGIONS.staleTime;
        if(isFresh(state.master.regions.last_fetched_at, STALE_TIME)){
           return rejectWithValue(ERROR.CACHED);
        }
        try {
            const regions = await fetchRegions(selectedAgencyId);
            return regions;
        } catch (error) {
            return rejectWithValue(getErrorMessage(error, 'An error occurred while fetching regions data'));
        }
    }
)